import { EmailRedirectionComponent } from './old-settings/email-redirection/email-redirection.component';
import { FirstloginComponent } from './firstlogin/firstlogin.component';
import { EmailIntegrationComponent } from './old-settings/email-integration/email-integration.component';
import { TeaminviteComponent } from './teaminvite/teaminvite.component';
import { PricingComponent } from './accounts/pricing/pricing.component';
import { SubscriptionUsageComponent } from './accounts/subscription-usage/subscription-usage.component';
import { IframeSearchtoolboxComponent } from './SearchBox/iframe-searchtoolbox/iframe-searchtoolbox.component';
import { ProfileDetailsComponent } from './user/profile-details/profile-details.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { OldSettingsComponent } from './old-settings/old-settings.component';
import { SignupComponent } from './signup/signup.component';
import { CandidateListComponent } from './candidate/candidate-list/candidate-list.component';
import { TalentpoolListComponent } from './talentpool/talentpool-list/talentpool-list.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SmartsearchComponent } from './SearchBox/smartsearch/smartsearch.component';
import { CreateCandidateComponent } from './candidate/create-candidate/create-candidate.component';
import { EmailTemplateComponent } from './old-settings/email-template/email-template.component';
import { CallLogSettingsComponent } from './old-settings/call-log-settings/call-log-settings.component';
import { SearchtoolboxV2Component } from './SearchBox/searchtoolbox-v2/searchtoolbox-v2.component';
import { ExpiryComponent } from "./expirylink/expirylink.component";
import { SearchtoolboxV3Component } from './SearchBox/searchtoolbox-v3/searchtoolbox-v3.component';
import { CompanydirectoryComponent } from './companypages/companydirectory/industrylist/companydirectory.component';
import { CompanyinfoComponent } from './companypages/companyinfo/companyinfo.component';
import { CompanylistComponent } from './companypages/companydirectory/companylist/companylist.component';
import { PersonSearchComponent } from './person-search/person-search.component';
import { PersonSearchListingComponent } from './person-search-listing/person-search-listing.component';
import { TalnepoolCandidateTabsComponent } from './talnepool-candidate-tabs/talnepool-candidate-tabs.component';
import { TalentpoolDetailsComponent } from './talentpool/talentpool-details/talentpool-details.component';
import { NewCompnayPageComponent } from './companypages/new-compnay-page/new-compnay-page.component';
import { CompanyListComponent } from './companypages/company-list/company-list.component';
import { DocumentPreviewComponent } from './candidate/candidate-slider/document-preview/document-preview.component';
import { CompanyDetailsComponent } from './companypages/company-details/company-details.component';
import { DiversityTabComponent } from './companypages/diversity-tab/diversity-tab.component';
import { EducationTabComponent } from './companypages/education-tab/education-tab.component';
import { SkillsTabComponent } from './companypages/skills-tab/skills-tab.component';
import { TalentmovementTabComponent } from './companypages/talentmovement-tab/talentmovement-tab.component';
import { TitlesTabComponent } from './companypages/titles-tab/titles-tab.component';
import { OverviewTabComponent } from './companypages/overview-tab/overview-tab.component';
import { AttrtionTabComponent } from './companypages/attrtion-tab/attrtion-tab.component';
import { LocationTabComponent } from './companypages/location-tab/location-tab.component';
import { CompprofileTabComponent } from './companypages/compprofile-tab/compprofile-tab.component';
import { ReportsComponent } from './reports/reports.component';
import { PersonalReportsComponent } from './reports/personal-reports/personal-reports.component';
import { TeamMembersReportsComponent } from './reports/team-members-reports/team-members-reports.component';
import { TalentpoolInsightsComponent } from './talentpool-insights/talentpool-insights.component';
import { ReportDetailsComponent } from './talentpool-insights/report-details/report-details.component';
import { ReportOverviewTabComponent } from './talentpool-insights/report-overview-tab/report-overview-tab.component';
import { ReportLocationTabComponent } from './talentpool-insights/report-location-tab/report-location-tab.component';
import { ReportEducationTabComponent } from './talentpool-insights/report-education-tab/report-education-tab.component';

import { ReportDiversityComponent } from './talentpool-insights/report-diversity/report-diversity.component';

import { ReportSkillsComponent } from './talentpool-insights/report-skills/report-skills.component';
import { ReportIndustriesComponent } from './talentpool-insights/report-industries/report-industries.component';
import { ReportCompanyComponent } from './talentpool-insights/report-company/report-company.component';
import { ReportProfilesComponent } from './talentpool-insights/report-profiles/report-profiles.component';
import { ReportTitlesComponent } from './talentpool-insights/report-titles/report-titles.component';
import { SharedTalentpoolsListingComponent } from './talentpool/shared-talentpools-listing/shared-talentpools-listing.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { AuthGuardGuard } from './_services/auth-guard.guard';
import { AccessRefreshGuard } from './_services/access-refresh.guard';
import { CreditsRefreshGuard } from './_services/credits-refresh.guard';
import { QuickSearchComponent } from './person-search/quick-search/quick-search.component';
import { AdvanceSearchComponent } from './person-search/advance-search/advance-search/advance-search.component';
import { SimilarCandidatesComponent } from './person-search/similar-candidates/similar-candidates.component';
import { JdSearchComponent } from './person-search/jd-search/jd-search.component';
import { WebbtreeTalentInsightsComponent } from './webtree-website/webbtree-talent-insights/webbtree-talent-insights.component';
import { WebbtreeFreemiumBannerComponent } from './webtree-website/webbtree-freemium-banner/webbtree-freemium-banner.component';
import { EuropeAccessDocumentComponent } from './europe-access-document/europe-access-document.component';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { NewsignupComponent } from './newsignup/newsignup.component';
import { SettingsComponent } from './settings/settings.component';
import { TagManagementComponent } from './settings/tag-management/tag-management.component';
import { ProfilesComponent } from './settings/profiles/profiles.component';
import { PlanComponent } from './settings/plan/plan.component';
import { CreditsComponent } from './settings/credits/credits.component';
import { TeamManagementComponent } from './settings/team-management/team-management.component';
import { EmailTemplatesComponent } from './settings/email-templates/email-templates.component';
import { EmailIntegrationsComponent } from './settings/email-integrations/email-integrations.component';
import { AtsIntegrationsComponent } from './settings/ats-integrations/ats-integrations.component';
import { SelfSignupComponent } from './self-signup/self-signup.component';
import { WebbtreeCompanyListComponent } from './companypages/webbtree-company-list/webbtree-company-list.component';
import { CompanyComparisonDetailsComponent } from './companypages/company-comparison-details/company-comparison-details.component';
import { SimilarCompaniesComponent } from './companypages/similar-companies/similar-companies.component';
import { ProjectListComponent } from './ai-sourcing/project-list/project-list.component';
import { ProjectDetailsComponent } from './ai-sourcing/project-details/project-details.component';
import { AiSourcingComponent } from './ai-sourcing/ai-sourcing.component';
import { JdDescriptionComponent } from './ai-sourcing/jd-description/jd-description.component';
import { AiSourcingInsightsComponent } from './ai-sourcing/ai-sourcing-insights/ai-sourcing-insights.component';
import { AiSourcingProfilesComponent } from './ai-sourcing/ai-sourcing-profiles/ai-sourcing-profiles.component';
import { AiSourcingReviewComponent } from './ai-sourcing/ai-sourcing-review/ai-sourcing-review.component';
import { AiSourcingLandingpageComponent } from './ai-sourcing/ai-sourcing-landingpage/ai-sourcing-landingpage.component';
import { EvaluationCriteriaComponent } from './ai-sourcing/evaluation-criteria/evaluation-criteria.component';
import { AiSourcingArchiveComponent } from './ai-sourcing/ai-sourcing-archive/ai-sourcing-archive.component';
import { AiSourcingShortlistComponent } from './ai-sourcing/ai-sourcing-shortlist/ai-sourcing-shortlist.component';
import { AiSourcingActivityComponent } from './ai-sourcing/ai-sourcing-activity/ai-sourcing-activity.component';
import { TalentInsightsFreeTrialBannerComponent } from './webtree-website/talent-insights-free-trial-banner/talent-insights-free-trial-banner.component';
import { IntegrationComponent } from './unified/integration/integration.component';
import { IntegrationCallbackComponent } from './unified/integration-callback/integration-callback.component';
import { AiResumeScreenerComponent } from './webtree-website/ai-resume-screener/ai-resume-screener.component';
import { SkillsTaxonomyComponent } from './skills-taxonomy/skills-taxonomy/skills-taxonomy.component';
import { AutopilotPermissionComponent } from './settings/autopilot-permission/autopilot-permission.component';
import { NlSearchComponent } from './nl-search/nl-search.component';
import { ResumeScreenComponent } from './resume-screen/resume-screen.component';
import { CandidateListingComponent } from './resume-screen/candidate-listing/candidate-listing.component';
import { CreateJobComponent } from './resume-screen/create-job/create-job.component';
import { JobDetailsComponent } from './resume-screen/job-details/job-details.component';
import { CampaignsLimitsComponent } from './settings/campaigns-limits/campaigns-limits.component';
import { HireCandidateListComponent } from './hire-person-search/hire-candidate-list/hire-candidate-list.component';
import { MyCandidatesComponent } from './my-candidates/my-candidates.component';
import { HireTalentInsightsComponent } from './hire-talent-insights/hire-talent-insights.component';


const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path : 'smartsearch' , component : SmartsearchComponent},
  // { path : 'candidate-list' , component : CandidateListComponent},
  // { path:  'candidate-list/talentpool/:id', component: CandidateListComponent},
  { path:  'createcandidate', component: CreateCandidateComponent},
  { path:  'signup', component: NewsignupComponent},
  { path:  'login', component: SignupComponent},
  { path:  'unsubscribe', component: UnsubscribeComponent},
  { path:  'set-password', component: CreatePasswordComponent},
  { path:  'forgetpassword', component: ResetpasswordComponent},
  { path:  'resetpassword', component: ResetpasswordComponent},
  { path:  'old-settings', component: OldSettingsComponent, canActivate:[AuthGuardGuard]},
  // { path:  'old-settings/emailtemplate', component: EmailTemplateComponent,canActivate:[AuthGuardGuard]},
  // { path:  'old-settings/calllog', component: CallLogSettingsComponent,canActivate:[AuthGuardGuard]},
  { path:  'feedback', component: FeedbackComponent},
  { path:  'profiledetails', component: ProfileDetailsComponent},
  { path:  'searchtoolbox-v2', component: SearchtoolboxV3Component, canActivate:[CreditsRefreshGuard]},
  { path:  'iframe-searchtoolbox', component: IframeSearchtoolboxComponent},
  { path:  'subscription/usage', component: SubscriptionUsageComponent},
  { path:  'subscription/history', component: SubscriptionUsageComponent},
  { path:  'subscription/pricing', component: PricingComponent},
  { path:  'teaminvite', component: TeaminviteComponent},
  { path:  'firstlogin', component: FirstloginComponent},
  // { path:  'settings/email-integration', component: EmailIntegrationComponent},
  { path: 'expiry', component: ExpiryComponent},
  { path: 'email_redirection', component: EmailRedirectionComponent},
  { path: 'company-directory/industries', component: CompanydirectoryComponent},
  { path: 'company-directory/:cname/:cid', component: CompanyinfoComponent},
  { path: 'company-directory/:industry', component: CompanylistComponent},
  // {
  //   path: 'person/search',
  //   component: PersonSearchComponent,
  //   children: [
  //     { path: '', component: QuickSearchComponent },
  //     { path: 'advance', component: AdvanceSearchComponent },
  //     { path: 'similar-candidate', component: SimilarCandidatesComponent },
  //     { path: 'job-description', component: JdSearchComponent }
  //   ]
  // },
  // {path: 'person/search/listing', component: PersonSearchListingComponent, canActivate:[AccessRefreshGuard]},
  {path: 'talentpool/details/:id', component: TalentpoolDetailsComponent},
  { path: 'talentpool/details/:id/suggestions', component: TalentpoolDetailsComponent },
  { path: 'companypage', component: NewCompnayPageComponent},
  { path: 'company-list', component: CompanyListComponent},

  { path: 'reports', component: ReportsComponent},
  { path: 'talentpool-insights', component: TalentpoolInsightsComponent, canActivate:[AuthGuardGuard, AccessRefreshGuard, CreditsRefreshGuard]},
  { path: 'report-details', component: ReportDetailsComponent,
      children:[
        { path: '', redirectTo: "report-overview", pathMatch: "full"},
        { path: 'report-overview', component: ReportOverviewTabComponent, canActivate:[AccessRefreshGuard] },
        { path: 'report-location', component: ReportLocationTabComponent, canActivate:[AccessRefreshGuard]},
        { path: 'report-education', component: ReportEducationTabComponent, canActivate:[AccessRefreshGuard]},
        { path: 'report-diversity', component: ReportDiversityComponent, canActivate:[AccessRefreshGuard]},
        { path: 'report-skills', component: ReportSkillsComponent, canActivate:[AccessRefreshGuard]},
        { path: 'report-industries', component: ReportIndustriesComponent, canActivate:[AccessRefreshGuard]},
        { path: 'report-company', component: ReportCompanyComponent, canActivate:[AccessRefreshGuard]},
        // report-profiles doesn't read any access flag - no guard needed
        { path: 'report-profiles', component: ReportProfilesComponent },
        { path: 'report-titles', component: ReportTitlesComponent, canActivate:[AccessRefreshGuard]},


      ]},

  { path: 'company-details/:company-id', component: CompanyDetailsComponent,
    children: [
      { path: "", redirectTo: "overview", pathMatch: "full"},
      { path: 'overview', component: OverviewTabComponent, canActivate:[AccessRefreshGuard] },
      { path: 'location', component: LocationTabComponent, canActivate:[AccessRefreshGuard]},
      { path: 'attrition', component: AttrtionTabComponent, canActivate:[AccessRefreshGuard]},
      // education, talent-movement, profile, diversity, similar-companies don't read any
      // access flag - no guard needed
      { path: 'education', component: EducationTabComponent },
      { path: 'skills', component: SkillsTabComponent, canActivate:[AccessRefreshGuard]},
      { path: 'titles', component: TitlesTabComponent, canActivate:[AccessRefreshGuard]},
      { path: 'talent-movement', component: TalentmovementTabComponent},
      { path: 'profile', component: CompprofileTabComponent},
      { path: 'diversity', component: DiversityTabComponent},
      { path: 'similar-companies', component: SimilarCompaniesComponent}

    ]
   },

  {path: 'document-preview/:candidateid/:docid', component: DocumentPreviewComponent},
  {
    path: 'talent',
    component: TalnepoolCandidateTabsComponent,
    children: [
      { path: "", redirectTo: "/projects", pathMatch: "full"},
      { path : 'candidate-list' , redirectTo: '/projects', pathMatch: "full"},
      { path : 'talentpool' , redirectTo: '/projects', pathMatch: "full"},
      { path : 'shared-talentpool', redirectTo: '/projects', pathMatch: "full"}

    ]
  },
  { path: 'reports', component: ReportsComponent,
    children: [
      { path: "", redirectTo: "personal-reports", pathMatch: "prefix"},
      { path: 'personal-reports',  component:PersonalReportsComponent, canActivate:[CreditsRefreshGuard]},
      { path: 'team-members',  component:TeamMembersReportsComponent}
    ]
  },
  {path: 'person/search/jd', component: PersonSearchComponent, canActivate:[AccessRefreshGuard]},
  { path: 'try-talent-insights', component: WebbtreeFreemiumBannerComponent},

  {path: 'eu-consent-document', component: EuropeAccessDocumentComponent},
  { path: 'webbtree-company-list', component: WebbtreeCompanyListComponent, canActivate:[CreditsRefreshGuard]},
  { path: 'company-compare', component: CompanyComparisonDetailsComponent},
  {
    path: 'ai-sourcing',
    children: [
      { path: '', redirectTo: '/projects', pathMatch: 'full' },
      { path: 'project-list', redirectTo: '/projects', pathMatch: 'full' },
      { path: 'project-details/:projecctnumber',
        children: [

          {path: 'autopilot-evaluation-criteria', redirectTo: '/projects', pathMatch: 'full'},
          // autopilot-activity doesn't read any access flag - no guard needed
          {path: 'autopilot-activity', redirectTo: '/projects', pathMatch: 'full'},
        ]
       },


      // { path: 'autopilot-evaluation-criteria/:projecctnumber', component: EvaluationCriteriaComponent },
      // { path: 'autopilot-activity/:projecctnumber', component: AiSourcingActivityComponent },
      { path: 'evaluation-criteria',  redirectTo: '/projects', pathMatch: 'full' },
      // { path: 'evaluation-criteria/:projecctnumber', component: EvaluationCriteriaComponent },
      { path: 'jd-description', redirectTo: '/projects', pathMatch: 'full' },
      { path: 'jd-description/:projecctnumber', redirectTo: '/projects', pathMatch: 'full' },
      // { path: 'landingpage', component: AiSourcingLandingpageComponent },
      { path: 'ai-sourcing-insights/:projectnumber',  redirectTo: '/projects', pathMatch: 'full' },
      { path: 'ai-sourcing-profiles',
        children: [
          { path: "", pathMatch: "full", redirectTo: '/projects' },
          { path: 'review/:projectnumber',  redirectTo: '/projects', pathMatch: 'full' },
          { path: 'archive/:projectnumber',  redirectTo: '/projects', pathMatch: 'full' },
          { path: 'shortlist/:projectnumber',  redirectTo: '/projects', pathMatch: 'full' },
          { path: 'activity/:projectnumber',  redirectTo: '/projects', pathMatch: 'full' },

          // { path: 'files', component: AiSourcingFilesComponent },
          // { path: 'contact', component: AiSourcingContactComponent },
          // { path: 'notes', component: AiSourcingNotesComponent }
        ]
      }

    ],

  },

  { path: 'talent-insights-free-trial', component:TalentInsightsFreeTrialBannerComponent},
  { path: 'skills-taxonomy-free-trial', component:SkillsTaxonomyComponent},

  {
    // SettingsComponent itself reads autopilotslotaccess (to show/hide the Autopilot nav tab),
    // so the shell needs the guard regardless of which child is active.
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AccessRefreshGuard, CreditsRefreshGuard],
    children: [
      { path: '', component: ProfilesComponent },
      { path: 'tag-management', component: TagManagementComponent },
      { path: 'plan', component: PlanComponent },
      { path: 'credits', component: CreditsComponent },
      // team-management and autopilot-permission also read access flags directly - the parent
      // guard above only fires on first entry into /settings (Angular reuses the shell across
      // child navigations), so these need their own guard to refresh on every visit to them.
      { path: 'team-management', component: TeamManagementComponent, canActivate: [AccessRefreshGuard] },
      { path: 'email-templates', component: EmailTemplatesComponent },
      { path: 'email-integrations', component: EmailIntegrationsComponent },
      { path: 'autopilot-permission', component: AutopilotPermissionComponent, canActivate: [AccessRefreshGuard] },
      { path: 'campaigns-limits', component: CampaignsLimitsComponent },

      // { path: 'ats-integrations', component: AtsIntegrationsComponent },
      {
        path: 'ats-integrations',
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'ats' },
          { path: 'ats', component: IntegrationComponent },
          { path: 'callback', component: IntegrationCallbackComponent },
          { path: ':category', component: IntegrationComponent }
        ]
      }
    ]
  },
  { path:  'self-signup', component: SelfSignupComponent},
  { path:  'resume-screener', component: AiResumeScreenerComponent},
  { path : 'person/search' , component : NlSearchComponent},
  { path: 'my-candidates', component: MyCandidatesComponent},
  { path: 'hire-talent-insights', component: HireTalentInsightsComponent},

{
  path: 'resume-screen',
  children: [
    { path: '', redirectTo: '/projects', pathMatch: 'full' },
    { path: 'job-details/:jobid', redirectTo: '/projects', pathMatch: 'full' },
    { path: 'create-job', redirectTo: '/projects', pathMatch: 'full' },
    { path: 'create-job/:jobid', redirectTo: '/projects', pathMatch: 'full' },
    { path: 'candidate-listing/:jobid', redirectTo: '/projects', pathMatch: 'full' },
    { path: '**', redirectTo: '/projects' }
  ]
},

   {
    path: '',
    loadChildren: () =>
      import('./hire-person-search/hire-person-search.route')
        .then(m => m.HIRE_SEARCH_ROUTES)
  },

  {
    path: 'projects',
    loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsModule)
  },

    {
    path: '',
    loadChildren: () => import('./hire-talent-insights/hire-talent-insights.module').then(m => m.HireTalentInsightsModule)
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
